module.exports = __webpack_public_path__ + "static/img/share.e490e1d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pcImg/share.png
// module id = t162
// module chunks = 1